// API surface — every screen reads through here.
// Modes:
//   - VITE_API_URL unset: falls back to bundled mock data.
//   - VITE_API_URL set + VITE_API_DEMO=1: hits real backend in demo mode
//     (no auth required; backend returns bundled demo dataset).
//   - VITE_API_URL set + auth token in localStorage("sd_token"): real data.

import { EVENTS, PLATFORMS } from "./mock.js";

const API = import.meta.env.VITE_API_URL || "";
const DEMO = import.meta.env.VITE_API_DEMO === "1";
const useMock = !API;

function authHeaders() {
  const tok = typeof localStorage !== "undefined" && localStorage.getItem("sd_token");
  return tok ? { Authorization: `Bearer ${tok}` } : {};
}

function withDemo(path) {
  if (!DEMO) return path;
  return path + (path.includes("?") ? "&" : "?") + "demo=1";
}

async function http(path, opts = {}) {
  const res = await fetch(`${API}${withDemo(path)}`, {
    ...opts,
    headers: { "Content-Type": "application/json", ...authHeaders(), ...(opts.headers || {}) },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export async function getEvents() {
  if (useMock) return new Promise((r) => setTimeout(() => r(EVENTS), 60));
  const { events } = await http("/api/aggregate/events");
  return events;
}

export async function getPlatforms() {
  if (useMock) return PLATFORMS;
  const { integrations } = await http("/api/aggregate/integrations");
  return integrations;
}

export async function getKpis() {
  if (useMock) {
    return {
      liveEvents: 14, ticketsSold24h: 1284, grossMonth: 48210.5,
      sellThrough: 73, refundRate: 0.8,
    };
  }
  return http("/api/aggregate/kpis");
}

export async function connectPlatform(platform, credentials) {
  return http(`/api/aggregate/integrations/${platform}/connect`, {
    method: "POST",
    body: JSON.stringify({ credentials }),
  });
}

export async function disconnectPlatform(platform) {
  return http(`/api/aggregate/integrations/${platform}/disconnect`, { method: "POST" });
}
